import store from '@/store'

export default async function redirectToLogin(from, next) {
    try {
        await store.dispatch('logout')
    } catch (e) {
        //
    }

    next('/login')
}
